var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg003SgExecute = function Svg003SgExecute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m20 20 32.057 12.029a79.998 79.998 0 0 1 43.907 64.452l21.074 236.447",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 452,
    r: 40,
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m283.37 401.976-13.945-159.391c-1.925-22.007 14.354-41.409 36.362-43.334l119.537-10.458a39.8 39.8 0 0 0-20.145-3.487L245.787 199.25c-22.007 1.926-38.287 21.327-36.362 43.334l13.945 159.391c1.925 22.007 21.327 38.287 43.334 36.361l39.855-3.487c-12.636-5.803-21.89-18.03-23.189-32.873z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.704 438.337c-22.007 1.925-41.409-14.354-43.334-36.362l-13.945-159.391c-1.925-22.007 14.354-41.409 36.362-43.334l159.391-13.945c22.007-1.925 41.409 14.354 43.334 36.362l13.945 159.391c1.925 22.007-14.354 41.409-36.362 43.334M325.483 192.278l6.972 79.695M171.646 446.654 492 418.626",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }));
};

export default Svg003SgExecute;